import React, { useState } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Chip,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { arrayOf, shape } from 'prop-types';
import * as R from 'ramda';

const Carriers = ({ carriers }) => {
  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });
  const [isExpanded, setExpanded] = useState(lgUp);

  const defaultToEmpty = R.defaultTo('');
  const getCityState = ({ carrierCity, carrierState }) =>
    `${defaultToEmpty(carrierCity)}${carrierCity ? ',' : ''} ${defaultToEmpty(carrierState)}`;

  return (
    <Accordion
      expanded={R.isEmpty(carriers) ? false : isExpanded}
      onChange={() => setExpanded(!isExpanded)}
    >
      <AccordionSummary
        aria-controls="carriers-content"
        expandIcon={<ExpandMoreIcon />}
        id="carriers"
      >
        <Stack direction="row" spacing={1}>
          <Typography variant="body2">
            {!R.isEmpty(carriers) ? 'Carriers' : 'All Carriers allowed to load'}
          </Typography>
          {!R.isEmpty(carriers) && carriers.length > 1 && (
            <Chip label={carriers.length} type="accordion" variant="badge" />
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Typography sx={{ mb: 2 }} variant="subtitle1">
          Allowed Carriers
        </Typography>
        <Stack direction="row" sx={{ mb: 1 }}>
          <Typography
            sx={{
              // eslint-disable-next-line sort-keys-fix/sort-keys-fix
              flex: { xs: 1, lg: 3 },
            }}
            variant="caption"
          >
            Carrier Name
          </Typography>
          <Typography
            sx={{
              // eslint-disable-next-line sort-keys-fix/sort-keys-fix
              flex: { xs: 1, lg: 2 },
              flexWrap: 'wrap',
            }}
            variant="caption"
          >
            {lgUp ? 'Carrier FEIN' : 'FEIN/City, State'}
          </Typography>
          <Typography
            sx={{
              // eslint-disable-next-line sort-keys-fix/sort-keys-fix
              display: { xs: 'none', lg: 'inline-flex' },
              flex: 1,
            }}
            variant="caption"
          >
            City, State
          </Typography>
        </Stack>
        {carriers.map(({ carrierFEIN, carrierId, carrierName, ...rest }) => (
          <Stack direction="row" key={carrierId}>
            <Typography
              sx={{
                // eslint-disable-next-line sort-keys-fix/sort-keys-fix
                flex: { xs: 1, lg: 3 },
              }}
              variant="subtitle2"
            >
              {carrierName}
            </Typography>
            <Typography
              sx={{
                // eslint-disable-next-line sort-keys-fix/sort-keys-fix
                flex: { xs: 1, lg: 2 },
              }}
              variant="subtitle2"
            >
              {lgUp ? carrierFEIN : `${carrierFEIN}\n${getCityState(rest)}`}
            </Typography>
            <Typography
              sx={{
                // eslint-disable-next-line sort-keys-fix/sort-keys-fix
                display: { xs: 'none', lg: 'inline-flex' },
                flex: 1,
              }}
              variant="subtitle2"
            >
              {getCityState(rest)}
            </Typography>
          </Stack>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

Carriers.propTypes = {
  carriers: arrayOf(shape({})),
};

Carriers.defaultProps = {
  carriers: [],
};

export default Carriers;
